import React from 'react';
import { SortButton } from '../../../../../search/components/sort';
import { InstitutionProps } from '../../../models/arc-epi-props';




interface Props {
	settings: InstitutionProps,
}

export function DbPlanHistoryLabels(props: Props) {

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.planNameLabel} name='name' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.adoptionDateLabel} name='adoption_date' />
			</div>

			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.assessmentLabel} name='assessment_percent' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.billingSchdeuleLabel} name='billing_schedule' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.terminationDateLabel} name='termination_date' />
			</div>
		</div>
	);

}